import i18next from 'i18next';
import { createAjaxAction } from '../../Common/_actions/AjaxAction';
import { Toast } from '../../UIData/_actions/UIDataActions';
import { InvalidatePaginationData } from './UserDataActions';

export enum UserImageActionType {
	UploadUserImage = 'USER_IMAGE_UPLOAD_USER_IMAGE',
	BatchDeleteImages = 'USER_IMAGE_BATCH_DELETE_IMAGES',
}

export interface BatchImageSelection {
	ids: number[]
	selectAll?: boolean
	excludeIds?: number[]
	filters?: {
		search?: string
	}
}

export const UploadUserImage = (data:FormData) => createAjaxAction(UserImageActionType.UploadUserImage, {
	url: "ajax/api/user/images/upload-file",
	method: "POST",
	data: data,
	onSuccess: (response, dispatch) => {
		dispatch(InvalidatePaginationData("images"));
	},
	onFailure: (response, dispatch) => {
		dispatch(Toast(i18next.t('Something went wrong!')));
	}
});

export const appendBatchImageSelection = (data: FormData, selection: BatchImageSelection) => {
	if (selection.selectAll) {
		data.append('select_all', '1');

		selection.excludeIds?.forEach((imageId) => {
			data.append('exclude_ids[]', String(imageId));
		});

		if (selection.filters?.search) {
			data.append('search', selection.filters.search);
		}

		return;
	}

	selection.ids.forEach((imageId) => {
		data.append('ids[]', String(imageId));
	});
}

export const BatchDeleteImages = (selection: BatchImageSelection) => {
	const data = new FormData();

	appendBatchImageSelection(data, selection);

	return createAjaxAction<{}>(UserImageActionType.BatchDeleteImages, {
		url: 'ajax/api/user/images/batch-delete',
		method: 'POST',
		data: data,
		onSuccess: (response, dispatch) => {
			dispatch(InvalidatePaginationData('images'));
		},
		onFailure: (response, dispatch) => {
			dispatch(Toast(i18next.t('Something went wrong!')));
		}
	});
}

export type UserImageAction = 
	ReturnType<typeof UploadUserImage> |
	ReturnType<typeof BatchDeleteImages>
